import React, { useState } from 'react';
import './preguntasFrecuentes.css';
import { Link, useLocation } from 'react-router-dom'; // Añadimos useLocation

const PreguntasFrecuentes = () => {
  const [preguntasAbiertas, setPreguntasAbiertas] = useState({});

  const preguntas = [
    {
      id: 6,
      pregunta: "¿Cuanto cuestan las mudanzas?",
      respuesta: "Dependera de donde la quieras puedes cotizar aqui",
      url: "/cotizaciones"
    },
    {
      id: 1,
      pregunta: "¿Cuentan con seguro?",
      respuesta: "Si contamos con varios tipos de seguros para hacer segura tu mudanza",
      url: "/seguros"

    },
    {
      id: 2,
      pregunta: "¿Pueden llevar mis muebles?",
      respuesta: "Claro. Tenemos camiones para todo tipo de transportes",
      url: "/camiones"
    },
    {
      id: 3,
      pregunta: "¿Cuando llegaran?",
      respuesta: "Las fechas se dan al momento de agendar. Pero tenemos sistema de rastreo para que esten mas seguros",
      url: "/seguimiento"
    },
    {
      id: 4,
      pregunta: "¿Ustedes embalan las cosas?",
      respuesta: "Claro nosotros nos encargamos de toda tu mudanza, Excepto de ordenar. Aqui algunos tips",
      url: "/embalaje"
    },
    {
      id: 5,
      pregunta: "¿Donde trabajan?",
      respuesta: "Trabajamos en todo el pais haciendo encargos y algunos al extranjero.",
      url: "/services"
    },
    
  ];

  const togglePregunta = (id) => {
    setPreguntasAbiertas(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className="preguntas-frecuentes-container">
      <div className="preguntas-frecuentes-header">
        <h1>PREGUNTAS FRECUENTES</h1>
      </div>

      <div className="preguntas-frecuentes-list">
        {preguntas.map((item) => (
          <div 
            key={item.id} 
            className={`pregunta-item ${preguntasAbiertas[item.id] ? 'abierta' : ''}`}
          >
            <button 
              className="pregunta-header"
              onClick={() => togglePregunta(item.id)}
            >
              <span className="pregunta-titulo">{item.pregunta}</span>
              <span className="pregunta-icono">
                {preguntasAbiertas[item.id] ? '−' : '+'}
              </span>
            </button>
            <div className="pregunta-contenido">
              <p>{item.respuesta}</p>
              <Link 
              to={item.url} 
              
            >
              Conocer Más
            </Link>
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreguntasFrecuentes; 